module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/blue-polygon-4801f5ccd65aa8d7a708dd31904cfdd3.svg";